import VerticalLogo from './vertical-icon.png'
import CoverNotAvailbale from './cover-not-available.png'
export { VerticalLogo, CoverNotAvailbale }
